import { AppIcon } from '@/shared/ui/icons'

export const Alert = ({
  title = '',
  subtitle = '',
  icon = 'square-exclamation',
  variant = 'primary',
  className = '',
  noBorder,
  children
}) => {
  return (
    <div
      className={`alert alert-${variant} ${noBorder ? 'border-0' : ''} ${className}`}
    >
      <AppIcon
        name={icon}
        className="mr-4 text-3xl shrink-0"
      />
      <div className="flex flex-col grow">
        {title && <h4 className="mb-1">{title}</h4>}
        {subtitle && <span>{subtitle}</span>}
        {children}
      </div>
    </div>
  )
}
